import { EducationInformation } from './EducationInformation';

export class PracticeHistoryDetails extends EducationInformation {
    employmentSetting: string;
    employmentSettingOptional: string;
    isCurrentPractice: string;
}
